(function importerDefinition() {
    'use strict';
    angular.module('Entities')
        .service('importerService', [
            'restUrlBuilder', '$injector', 'config', function importerService(restUrlBuilder, $injector, config) {

                this.create = function importerCreate(files) {
                    if (files == null || files.size <= 0) {
                        throw "file no puede ser null";
                    }
                    
                    var url = config.appUrl('/Home/Index#/pwd-reset/?code={0}');
                    var $upload = $injector.get('Upload');

                    if ($upload == null)
                        throw "No se pudo instanciar $upload. Verifique que se cargó el script ng-file-upload";

                    return $upload.upload({
                        url: config.apiUrl('/Importer/'),
                        method: 'POST',
                        fields: { systemUrl: url },
                        file: files,
                        fileFormDataName: 'imageFile'
                    });
                };
            }
        ]);
})();